import { Component, Input, OnInit } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

@Component({
  selector: 'formly-label-field',
  templateUrl: './formly-label-field.component.html',
  styleUrls: ['./formly-label-field.component.scss'],
})
export class FormlyLabelFieldComponent extends FieldType implements OnInit {
  @Input() text: string;

  constructor() {
    super();
  }

  ngOnInit(): void {
    this.text = this.to.defaultValue;
  }
}
